import PartnerPDPLandingForm from './PartnerPDPLandingForm'

export default PartnerPDPLandingForm
